const MyLocation = () => <span className="me" role="img" aria-label="My location">🔵</span>;

export default MyLocation;
